module.exports = __webpack_public_path__ + "static/img/langhuaduoduo.97b75df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/langhuaduoduo.png
// module id = 1xCC
// module chunks = 36